<script setup lang="ts">
import { computed, ref } from 'vue'

import { useBetaCanvasScale } from '@/components/beta-editor/canvas/atoms/useBetaCanvasScale'

const props = defineProps<{
    logicalWidth: number
}>()

const viewportRef = ref<HTMLElement | null>(null)
const contentRef = ref<HTMLElement | null>(null)
const logicalWidthRef = computed(() => props.logicalWidth)
const { scale, scaledWidth, scaledHeight } = useBetaCanvasScale({
    viewportRef,
    contentRef,
    logicalWidth: logicalWidthRef,
})

const sizerStyle = computed(() => ({
    width: `${scaledWidth.value || props.logicalWidth}px`,
    height: scaledHeight.value ? `${scaledHeight.value}px` : 'auto',
}))

const contentStyle = computed(() => ({
    width: `${props.logicalWidth}px`,
    transform: `scale(${scale.value})`,
}))
</script>

<template>
    <div
        ref="viewportRef"
        class="beta-canvas-fit-frame"
        :data-scale-active="scale < 1"
        :style="{ '--beta-canvas-fit-scale': scale }"
    >
        <div class="beta-canvas-fit-frame__sizer" :style="sizerStyle">
            <div ref="contentRef" class="beta-canvas-fit-frame__content" :style="contentStyle">
                <slot :scale="scale" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.beta-canvas-fit-frame {
    @apply flex w-full justify-center overflow-visible;
}

.beta-canvas-fit-frame__sizer {
    @apply relative flex-none overflow-visible transition-all duration-200;
}

.beta-canvas-fit-frame__content {
    @apply origin-top-left overflow-visible transition-transform duration-200;
    will-change: transform;
}
</style>
